var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgThumbsUpFilled16 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.44.74c.78 0 1.5.3 2.05.85.54.54.85 1.29.85 2.05v1.04h3.7c.25 0 .5.05.73.16.23.1.44.26.6.45.17.19.29.41.36.65.07.24.09.5.06.75l-.84 6.75c-.05.43-.26.82-.58 1.11-.32.29-.74.44-1.17.45H1.25c-.32 0-.63-.13-.86-.36a1.22 1.22 0 0 1-.36-.86V7.59c0-.32.13-.63.36-.86.23-.23.53-.35.86-.35h2.97l2.63-5.27c.11-.22.34-.36.58-.36l.01-.01ZM3.97 7.66H1.33v6.02h2.64V7.66Z"
  })));
});
SvgThumbsUpFilled16.displayName = "SvgThumbsUpFilled16";
export default SvgThumbsUpFilled16;